<div class="container">
  <div class="row">
    <div class="col-md-11 col-sm-9 dgx-panel-left">
      <div class="panel panel-table">
        <div class="panel-heading">
          <h3 class="panel-title"> TOOLKIT DATA EXCHANGE (DGX) HOME
          </h3>
        </div>
        <div class="panel-body fixed-panel">
          <p> <strong>This DGX test site demonstrates all the supported transactions and presents the Data Integration
              Toolkit requests and responses in XML format.</strong></p>
          <p>The Java and COM Data Integration Toolkits use Extensible Markup Language (XML) transactions to communicate
            between your client and the D&B server. However, if you are sending XML transactions directly to D&B,
            Toolkit Data Exchange (DGX) test pages are available to assist you in creating your direct XML transactions.
          </p>
          <p>You will also need documentation on the structure of both the request and response XML documents. The
            preferred method to achieve these goals is to use the Data Integration XML Schema Definitions or XSDs. See
             <a [routerLink]="'/locked/xml-product-data-sheet'" role="link" aria-label="XML Data Integration Toolkit">XML Data Integration Toolkit</a>.</p>
          <p>Unless your user ID has been set up as a test ID, requests that involve placing new product orders will be
            treated as standard requests and are chargeable.</p>

        </div>
      </div>
    </div>
  </div>
</div>
 